/** @jsxImportSource @emotion/react */

import { formatCurrency } from "helpers/formatCurrency";
import { Fragment } from "react";

import { useGetBalanceDV } from "api/user/query";
import { BalanceStyle } from "./index.style";

interface BalanceProps {
  color?: string;
}

function Balance({ color = "#feea11" }: BalanceProps) {
  const { data: balance, isLoading } = useGetBalanceDV()
  // const [open, setOpen] = useState<boolean>(false);
  if (isLoading) return null;
  return (
    <Fragment>
      <div css={BalanceStyle.index(false, color, "ct")}>
        <div
          // onClick={() => {
          //   setOpen(true);
          // }}
          className="icon_inforMoney"
        >
          <span className="ng-binding ng-scope">
            {formatCurrency(Math.trunc(Number(balance?.main_balance)) || 0)}
          </span>
          {/* <span className="btn_inforOut"></span> */}
        </div>
      </div>
      {/* <GameMenu open={open} onClose={() => setOpen(false)} /> */}
    </Fragment>
  );
}

export default Balance;
